import { create } from 'zustand';
import type { DeviceStore } from '@/store/about/storeTypes';

export const useDeviceStore = create<DeviceStore>((set) => ({
  deviceType: 'desktop',
  clientInfo: 'Unknown OS, Unknown Browser',
  setDeviceInfo: (info) => set((state) => ({ ...state, ...info })),
}));
